import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ClientProvider } from "@/context/ClientContext";
import Login from "@/pages/Login";
import DashboardLayout from "@/components/DashboardLayout";
import Overview from "@/pages/Overview";
import Composer from "@/pages/Composer";
import BatchGenerator from "@/pages/BatchGenerator";
import StudioIA from "@/pages/StudioIA";
import Assistant from "@/pages/Assistant";
import ConnectInstagram from "@/pages/ConnectInstagram";
import Gallery from "@/pages/Gallery";
import MediaLibrary from "@/pages/MediaLibrary";
import CalendarView from "@/pages/CalendarView";
import Clients from "@/pages/Clients";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Legal from "@/pages/Legal";
import Privacy from "@/pages/Privacy";
import { Loader2 } from "lucide-react";

const TOAST_OPTIONS = {
  style: {
    background: "#111111",
    border: "1px solid rgba(253,251,247,0.12)",
    color: "#FDFBF7",
    borderRadius: "2px",
  },
};

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={TOAST_OPTIONS}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/connect-instagram/:token" element={<ConnectInstagram />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <ClientProvider>
                    <DashboardLayout />
                  </ClientProvider>
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="composer" element={<Composer />} />
              <Route path="lot" element={<BatchGenerator />} />
              <Route path="studio" element={<StudioIA />} />
              <Route path="galerie" element={<Gallery />} />
              <Route path="mediatheque" element={<MediaLibrary />} />
              <Route path="calendrier" element={<CalendarView />} />
              <Route path="clients" element={<Clients />} />
              <Route
                path="equipe"
                element={
                  <AdminRoute>
                    <Team />
                  </AdminRoute>
                }
              />
              <Route path="parametres" element={<Settings />} />
              <Route path="legal" element={<Legal />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
